module.exports = __webpack_public_path__ + "static/media/airbnb.cfa9fd4f.svg";